<template>
  <div>
    <div v-if="isRandomShow">
      <div class="hp-title">
        <div>&nbsp;</div>
        <span>随机抽取专家</span>
        <p>注：请先填写“专业名称”和“专家人数” &nbsp;&nbsp;
          <a-popconfirm title="是否信息设置筛选条件?" ok-text="是" cancel-text="否" @confirm="updateLotto">
            <a v-if="true" v-show="ifA && !expertName && isReDraw" style="padding-right: 30px">更改随机抽取筛选条件</a>
          </a-popconfirm>
        </p>
      </div>
      <!--随机抽取列表-->
      <a-table v-show="ifA"
               :bordered="true"
               :columns="columns2"
               :pagination="false"
               :rowKey="record => record.id"
               :data-source="selectExpertList">
        <template slot="name" slot-scope="record">
          <a @click="onViewModal(record)">{{ record.name }}</a>
        </template>
        <template slot="operation" slot-scope="record">
          <a-button-group>
            <a-button @click="onConfirm(record)" :loading="loading" type="primary">确定</a-button>&nbsp;
          </a-button-group>
        </template>
      </a-table>
      <!--整组情况-->
      <s-table v-show="false"
               ref="table"
               :bordered="true"
               :columns="columns2"
               :data="loadData"
               :pagination="{ showTotal: (total) => `共 ${total} 条` }"
               :rowKey="record => record.id">
        <template slot="name" slot-scope="record">
          <a @click="onViewModal(record)">{{ record.name }}</a>
        </template>
        <template slot="operation" slot-scope="record">
          <a-button @click="onViewReSelectModal(record,'2')" :loading="loading" type="primary">确定</a-button>&nbsp;
        </template>
      </s-table>
      <a-row type="flex" justify="center" v-if="ifQueryParam">
        <a-col :span="6">
          <a-button v-show="ifA && !expertName && !isReDraw" @click="onLottoModal()" type="primary" style="margin-left: 5px">随机生成</a-button>
          <a-button v-show="ifA && !expertName && isReDraw" @click="onViewReSelectModal('','3')" type="primary" style="margin-left: 5px">随机生成</a-button>
          <a-button @click="doWholeInfo('0')" type="primary" style="margin-left: 5px">整组情况</a-button>
          <!--          <a-button v-show="!ifA" @click="() => { $emit('changeIfA', true) }" type="primary" style="margin-left: 5px">返回</a-button>-->
        </a-col>
      </a-row>
    </div>

    <div class="hp-title">
      <div>&nbsp;</div>
      <span>确定抽取专家</span>
      <a-button v-if="!isRandomShow && ifQueryParam" type="primary" shape="round" @click="doWholeInfo('1')" style="margin-left: 20px">选取专家</a-button>
    </div>
    <a-table :bordered="true"
             :columns="columns2"
             :pagination="false"
             :rowKey="record => record.id"
             :data-source="confirmExpertList">
      <template slot="name" slot-scope="record">
        <a @click="onViewModal(record)">{{ record.name }}</a>
      </template>
      <template slot="operation" slot-scope="record">
        <a-button-group>
          <a-button @click="onViewReSelectModal(record,'1')" :loading="loading" type="primary">取消</a-button>&nbsp;
        </a-button-group>
      </template>
    </a-table>
    <expertView-modal :visible="evmVisible" :id="evmId" @cancel="evmVisible = false; evmId = null"/>

    <!-- 显示取消的专家 -->
    <div v-if="cSelectList.length > 0">
      <div class="hp-title">
        <div>&nbsp;</div>
        <span>专家取消记录</span>
      </div>
      <a-table :bordered="true"
               :columns="columns3"
               :pagination="false"
               :rowKey="record => record.id"
               :data-source="cSelectList">

      </a-table>
    </div>

    <a-modal :title="reSelectTitle" v-model="reSelectVisible" :width="960" @ok="onOkReSelectModal">
      <table class="fx-form-view">
        <col width="150px"/>
        <col/>
        <tr>
          <th>专家名称</th>
          <td colspan="3">
            <div v-if="reSelectState === '3'">
              <span v-for="expert in selectExpertList">{{ expert.name }} &nbsp;</span>
            </div>
            <div v-else>{{ reSelectExpert.name }}</div>
          </td>
        </tr>
        <tr>
          <th>是否回避</th>
          <td colspan="3">
            <a-radio-group v-model="debarb">
              <a-radio :value="'1'">是</a-radio>
              <a-radio :value="'0'">否</a-radio>
            </a-radio-group>
          </td>
        </tr>
        <tr>
          <th>理由</th>
          <td colspan="3">
            <a-textarea v-model="reSelectReason" :rows="2"/>
          </td>
        </tr>
      </table>
    </a-modal>
    <select-expert-modal ref="selectExpertModal" :visible="modalVisible.selectExpert" @success="onDetailSuccess" @cancel="modalVisible.selectExpert = false"/>
    <select-condition-modal ref="selectConditionModal"  @success="onConditionSuccess" @cancel="onConditionCancel"/>
  </div>
</template>

<script>
import STable from '@/components/Table'
import expertViewModal from '@/epp/expertmain/expertInfo/common/ExpertViewModal.vue'
import SelectExpertModal from '@/epp/expertmain/selectexpertapply/modal/SelectExpertModal'
import SelectConditionModal from '@/epp/expertmain/selectexpertapply/common/SelectConditionModal'
import qs from 'qs'

const columns = [
  { title: '姓名', align: 'center', width: 100, scopedSlots: { customRender: 'name' } },
  { title: '年龄', align: 'center', dataIndex: 'extras.age', width: 100 },
  { title: '性别', align: 'center', width: 80, dataIndex: 'gender', customRender: (text, record) => { return text === '1' ? '男' : '女' } },
  { title: '拟申报组别', align: 'center', width: 200, dataIndex: 'extras.groups_name', customRender: (text, record) => { return text.length > 6 ? text.substring(0, 6) + '...' : text } },
  { title: '联系电话', align: 'center', width: 120, dataIndex: 'mobilePhone' },
  { title: '单位全称', align: 'center', dataIndex: 'unitName' }
]
const columns2 = [...columns, { title: '操作', width: 150, align: 'center', scopedSlots: { customRender: 'operation' } }]

export default {
  name: 'SelectExpertTable',
  components: {
    SelectConditionModal,
    SelectExpertModal,
    STable,
    expertViewModal
  },
  props: {
    ifA: { default: true, type: Boolean }, // true 是随机选取专家列表，false 是符合条件的专家列表
    professionalName: { default: null }, // 选取专家所需专业
    expertNumber: { default: 0, type: Number }, // 选取专家数
    expertName: String, // 指定专家名
    cfmZJList: { default: () => [], type: Array }, // 选取专家数
    // 是否显示随机功能
    isRandomShow: { default: true, type: Boolean }
  },
  data () {
    return {
      columns: columns,
      columns2: columns2,
      columns3: [
        { title: '姓名', align: 'center', width: 100, dataIndex: 'expertName', key: 'name' },
        { title: '年龄', align: 'center', dataIndex: 'age', width: 100 },
        { title: '性别', align: 'center', width: 80, dataIndex: 'gender', customRender: (text, record) => { return text === '1' ? '男' : '女' } },
        { title: '拟申报组别', align: 'center', width: 200, dataIndex: 'groupsName', ellipsis: true },
        { title: '联系电话', align: 'center', width: 120, dataIndex: 'mobilePhone' },
        { title: '取消理由', align: 'center', dataIndex: 'reason', ellipsis: true }
      ],
      user: this.$ls.get('user'),
      // 专家详情模态框
      evmVisible: false,
      evmId: null,
      // 重抽理由模态框
      reSelectVisible: false,
      reSelectTitle: null,
      reSelectExpert: { id: null, name: null },
      debarb: '0',
      reSelectReason: null,
      reSelectState: '1',
      reSelectList: [],
      cSelectList: [],

      // 取消选取专家列表
      cancelExpertList: [],
      // 确定选取专家列表
      confirmExpertList: [],
      // 随机选取专家列表
      selectExpertList: [],
      // 符合条件的专家列表
      expertList: [],
      // 符合条件的专家总数
      total: '',
      loading: false,
      modalVisible: {
        selectExpert: false
      },
      isCondition: false,
      isReDraw: false,
      loadData: parameter => {
        const that = this
        // 有参数 才查询
        var ifParam = false
        // 入库专家 和 没有删除 才可以参与任务
        const data = { state: '20', ifDelete: '0' }
        // 查询所有记录
        data.selectAll = true
        // 是否抽取专家查询
        data.ifExtractQuery = true
        if (this.professionalName) {
          ifParam = true
          data.groups = this.professionalName
        }
        if (this.expertName) {
          ifParam = true
          data.name = this.expertName
          data.ifExtractQuery = false
          data.groups = ''
        }
        if (!ifParam) {
          return
        }
        data.type = '0'
        data.state = '1'
        return this.$http.get('/api/1/expertmain/expertInfo/query_expert_info_list.json', { params: Object.assign(parameter, data) }).then(res => {
          if (res.page) {
            this.total = res.page.total
          }
          that.expertList = res.extras.listAll
          // console.log('that.expertList', that.expertList)
          return res
        })
      }
    }
  },
  computed: {
    ifQueryParam () {
      if (this.expertNumber && (this.professionalName || this.expertName)) {
        // this.$message.error('请将“专业名称”和“专家人数”补全！')
        return true
      }
      return false
    }
  },
  watch: {
    professionalName (val) {
      this.onRefresh()
    },
    expertName (val) {
      this.onRefresh()
    },
    cfmZJList (val) {
      this.confirmExpertList = this.cfmZJList
    }
    // ifA (val) {
    //   this.onRefresh()
    // },
  },
  created () {
  },
  methods: {
    // 刷新数据
    onRefresh () {
      this.$refs.table.refresh()
      this.selectExpertList = []
      // this.confirmExpertList = []
      this.cancelExpertList = []
    },
    onViewModal (record) {
      this.evmVisible = true
      this.evmId = record.id
    },
    onViewReSelectModal (record, state) {
      this.reSelectExpert = record
      this.reSelectState = state
      if (this.reSelectState === '1') {
        this.reSelectExpert.debarb = 0
        this.cancelExpertList.push(record)
        this.reSelectTitle = '重抽专家理由'
      } else if (this.reSelectState === '2') {
        this.reSelectExpert.debarb = 0
        this.reSelectTitle = '指定专家理由'
      } else if (this.reSelectState === '3') {
        this.reSelectTitle = '再次随机生成理由'
        this.reSelectExpert = {}
        this.reSelectExpert.debarb = 0
      }
      this.reSelectVisible = true
    },
    onOkReSelectModal () {
      let data = null
      if (this.reSelectState === '1') {
        // 重抽专家
        data = {
          expertId: this.reSelectExpert.id,
          expertName: this.reSelectExpert.name,
          reason: this.reSelectReason,
          state: this.reSelectState,
          debarb: this.debarb,
          age: this.reSelectExpert.extras.age,
          groupsName: this.reSelectExpert.extras.groups_name,
          mobilePhone: this.reSelectExpert.mobilePhone,
          gender: this.reSelectExpert.gender
        }
        this.reSelectList.push(data)
        this.onCancel(this.reSelectExpert)
      } else if (this.reSelectState === '2') {
        // 指定专家
        data = {
          expertId: this.reSelectExpert.id,
          expertName: this.reSelectExpert.name,
          reason: this.reSelectReason,
          state: this.reSelectState,
          debarb: this.debarb
        }
        this.reSelectList.push(data)
        this.onConfirm(this.reSelectExpert)
      } else if (this.reSelectState === '3') {
        // 随机生成
        // var expertIdList = [] // 随机选取的专家id集合
        // var expertNameList = [] // 随机选取的专家名称集合
        // this.selectExpertList.forEach(item => {
        //   expertIdList.push(item.id)
        //   expertNameList.push(item.name)
        // })
        // data = {
        //   expertId: expertIdList.join(','),
        //   expertName: expertNameList.join(','),
        //   reason: this.reSelectReason,
        //   state: this.reSelectState,
        //   debarb: this.debarb
        // }

        this.selectExpertList.forEach(item => {
          data = {
            expertId: item.id,
            expertName: item.name,
            reason: this.reSelectReason,
            state: this.reSelectState,
            debarb: this.debarb,
            age: item.extras.age,
            groupsName: item.extras.groups_name,
            mobilePhone: item.mobilePhone,
            gender: item.gender
          }

          var cTrue = false
          this.cSelectList.forEach(c => {
            if (data.expertId === c.expertId) {
              cTrue = true
            }
          })
          if (!cTrue) {
            this.cSelectList.push(data)
            this.reSelectList.push(data)
          }
        })
        this.onLotto()
      }
      this.reSelectVisible = false
      this.initReSelectModal()
    },
    initReSelectModal () {
      this.reSelectExpert = { id: null, name: null }
      this.reSelectReason = null
    },
    // 确认专家
    async onConfirm (record) {
      let data = null
      // 跳过第一次添加
      if (this.confirmExpertList.length > 0) {
        // 避免重复添加
        let ifExist = false
        this.confirmExpertList.map(item => {
          if (item.id === record.id) {
            ifExist = true
          }
        })
        if (!ifExist) {
          await this.confirmExpertList.push(record)
          this.selectExpertList = await this.selectExpertList.filter(item => item.id !== record.id)
          this.onChangeExpert()
        }
      } else {
        await this.confirmExpertList.push(record)
        this.selectExpertList = await this.selectExpertList.filter(item => item.id !== record.id)
        this.onChangeExpert()
      }
      if (this.selectExpertList.length > 0) {
        this.isReDraw = true
      } else {
        this.isReDraw = false
      }
    },
    // 取消专家
    async onCancel (record) {
      this.confirmExpertList = await this.confirmExpertList.filter(item => item.id !== record.id)
      this.onChangeExpert()
    },
    onDetailSuccess (data, confirm) {
      this.reSelectList = data
      this.confirmExpertList = confirm
      this.modalVisible.selectExpert = false
      if (this.isRandomShow) {
        this.onLotto()
      }
      this.onChangeExpert()
    },
    // 将数据（专家ids）返回
    onChangeExpert () {
      var expertIdList = [] // 随机选取的专家id集合
      var expertNameList = [] // 随机选取的专家名称集合
      this.confirmExpertList.forEach(item => {
        expertIdList.push(item.id)
        expertNameList.push(item.name)
      })
      this.$emit('change', expertIdList.join(','), expertNameList.join(','))
      this.$emit('changeReSelect', this.reSelectList)
    },
    onLottoModal () {
      this.isCondition = false
      // 弹出设置的条件
      this.$refs.selectConditionModal.onStartLoadData(true)
    },
    updateLotto () {
      // 弹出设置的条件
      this.$refs.selectConditionModal.onStartLoadData(true)
    },
    // 抽取
    onLotto () {
      // 清空随机选取专家的列表
      if (this.selectExpertList.length > 0) {
        this.selectExpertList.length = []
      }
      // (如果有已抽取的) 符合条件的专家 去掉 已抽取的专家
      var eList = []
      if (this.confirmExpertList.length > 0) {
        eList = this.expertList.filter(item => {
          var b = true
          this.confirmExpertList.forEach(confItem => {
            if (item.id === confItem.id) {
              b = false
            }
          })
          return b
        })
      } else {
        eList = this.expertList
      }
      // (如果有已取消的) 符合条件的专家 去掉 已取消的专家
      if (this.cancelExpertList.length > 0) {
        eList = eList.filter(item => {
          var b = true
          this.cancelExpertList.forEach(cancelItem => {
            if (item.id === cancelItem.id) {
              b = false
            }
          })
          return b
        })
      }

      // 随机数集合
      var sjsList = []
      // 符合条件的专家总数 大于等于（>=） 所需专家数
      // (?) 等于所需专家数 否则
      // (:) 等于符合条件的专家总数
      var LottoNumber = eList.length >= this.expertNumber - this.confirmExpertList.length ? this.expertNumber : eList.length
      // 如果已经存在 确定选取专家 ，则 随机抽取时 减少 对应确定专家的数量
      LottoNumber = LottoNumber > this.confirmExpertList.length ? LottoNumber - this.confirmExpertList.length : LottoNumber

      for (let i = 0; i < LottoNumber; i++) {
        // 随机数
        let sjs = Math.floor(Math.random() * eList.length)
        // 如果抽到重复随机数，重抽
        while (sjsList.includes(sjs)) {
          sjs = Math.floor(Math.random() * eList.length)
        }
        this.selectExpertList.push(eList[sjs])
        sjsList.push(sjs)
      }

      var getData = []
      this.selectExpertList.forEach(item => {
        var iIsTrue = false
        this.cSelectList.forEach(c => {
          if (item.id === c.expertId) {
            iIsTrue = true
          }
        })
        if (!iIsTrue) {
          getData.push(item)
        }
      })
      this.selectExpertList = []
      if (getData.length > 0) {
        this.selectExpertList = getData
      }
      if (this.selectExpertList.length > 0) {
        this.isReDraw = true
      } else {
        this.isReDraw = false
      }
    },
    doWholeInfo (type) {
      this.modalVisible.selectExpert = true
      // 有参数 才查询
      var ifParam = false
      // 入库专家 和 没有删除 才可以参与任务
      const data = { state: '20', ifDelete: '0' }
      // 查询所有记录
      data.selectAll = true
      // 是否抽取专家查询
      data.ifExtractQuery = true
      if (this.professionalName) {
        ifParam = true
        data.groups = this.professionalName
      }
      if (this.expertName) {
        ifParam = true
        data.name = this.expertName
        data.ifExtractQuery = false
        data.groups = ''
      }
      if (!ifParam) {
        return
      }
      data.type = '0'
      data.state = '1'
      this.$refs.selectExpertModal.onStartLoadData(data, this.confirmExpertList, type)
    },
    onConditionSuccess (data) {
      if (this.isCondition) {
        return
      }
      this.onUpdateExpert(data)
      // this.onLotto()
    },
    onConditionCancel () {
      this.isCondition = true
    },
    // 筛选一波专家
    onUpdateExpert (val) {
      if (val.isUpdate === false) {
        return
      }

      const that = this
      // 有参数 才查询
      var ifParam = false
      // 入库专家 和 没有删除 才可以参与任务
      const data = { state: '20', ifDelete: '0' }
      // 查询所有记录
      data.selectAll = true
      // 是否抽取专家查询
      data.ifExtractQuery = true
      if (that.professionalName) {
        ifParam = true
        data.groups = that.professionalName
      }
      if (that.expertName) {
        ifParam = true
        data.name = that.expertName
        data.ifExtractQuery = false
        data.groups = ''
      }
      if (!ifParam) {
        return
      }
      data.type = '0'
      data.state = '1'

      data.ageEt = val.ageEt
      data.ageSt = val.ageSt
      data.professionalTitle = val.professionalTitle
      data.gender = val.gender
      that.$http.post('/api/1/expertmain/expertInfo/get_expertInfo_list.json', qs.stringify(data)).then(res => {
        if (res.code !== 200) {
          return
        }
        // 已选
        var getData = []
        for (var i = res.result.length - 1; i >= 0; i--) {
          that.confirmExpertList.forEach(c => {
            if (res.result[i].id === c.id) {
              getData.push(c)
            }
          })
        }

        // 取消
        var cSData = []
        for (var i = res.result.length - 1; i >= 0; i--) {
          this.cSelectList.forEach(c => {
            if (res.result[i].id === c.expertId) {
              cSData.push(c)
            }
          })
        }

        var counts = (res.result.length - getData.length - cSData.length)

        that.$message.success(`本次条件筛选，可选专家人数为：${counts}`)
        if (counts >= that.expertNumber) {
          that.expertList = res.result
          that.onLotto()
        } else {
          that.$message.success(`本次条件筛选，与预期设置所需的专家人数不符，请重新设置筛选条件`)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.hp-title {
  padding-top: 15px;
  padding-bottom: 15px;
}

.hp-title div {
  height: 18px;
  border-left: 5px solid dodgerblue;
  width: 15px;
  display: inline-block;
}

.hp-title span {
  font-size: 16px;
  font-weight: bold
}
</style>
